import { render, staticRenderFns } from "./activity-booth.vue?vue&type=template&id=4c9d4ffc&scoped=true&"
import script from "./activity-booth.vue?vue&type=script&lang=js&"
export * from "./activity-booth.vue?vue&type=script&lang=js&"
import style0 from "./activity-booth.vue?vue&type=style&index=0&id=4c9d4ffc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d4ffc",
  null
  
)

export default component.exports